import axios from "./axios";
import * as Requests from "./requests";

export const getBrandCategory = (token: string) => {
  return axios.get(Requests.GET_BRAND_CATEGORY_API, {
    headers: {
      token,
    },
    baseURL: process.env.REACT_APP_DASHBOARD_ENDPOINT,
  });
};
